export default {
  masterChef: {
    20: '0x7F5489f77Bb8515DE4e0582B60Eb63A7D9959821',
  },
  swapRewardsChef: {
    20: '0x80f2cF7059336b44a75F00451B81f8d742DD2b94',
  },
  liquidStaking: {
    20: '0xa09909a3F3413675a0cF096C474100b1E4d457De',
  },
  cakeVault: {
    20: '0xBe224bb2EFe1aE7437Ab428557d3054E63033dA9',
  },
  materialChef: {
    20: '0x217da50b13682e74b519b3bb94b586d964e5f3ba',
  },
  phantzPool: {
    20: '0xbe080A1Fee90c12fC7F308590DC56929E407aA6E',
  },
  phantzV2Pool: {
    20: '0x6be4661405096e1dEEC1eD03250bB9d38aeA0804',
  },
  sousChef: {
    20: '0x9999999999999999999999999999999999999999',
  },
  lotteryV2: {
    20: '0x9999999999999999999999999999999999999999', // avoid ENS errors
  },
  multiCall: {
    // Multicall2
    1: '0x0555fcE4231A25AcB648284bfecf6B85e1AF6Bd4',
    20: '0x0555fcE4231A25AcB648284bfecf6B85e1AF6Bd4',
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    128: '0x0555fcE4231A25AcB648284bfecf6B85e1AF6Bd4',
  },
  pancakeProfile: {
    20: '0x9999999999999999999999999999999999999999',
  },
  pancakeRabbits: {
    20: '0x9999999999999999999999999999999999999999',
  },
  bunnyFactory: {
    20: '0x9999999999999999999999999999999999999999',
  },
  claimRefund: {
    20: '0x9999999999999999999999999999999999999999',
  },
  pointCenterIfo: {
    20: '0x9999999999999999999999999999999999999999',
  },
  bunnySpecial: {
    20: '0x9999999999999999999999999999999999999999',
  },
  tradingCompetition: {
    20: '0x9999999999999999999999999999999999999999',
  },
  easterNft: {
    20: '0x9999999999999999999999999999999999999999',
  },
  predictions: {
    20: '0x9999999999999999999999999999999999999999',
  },
  chainlinkOracle: {
    20: '0x9999999999999999999999999999999999999999',
  },
  bunnySpecialCakeVault: {
    20: '0x9999999999999999999999999999999999999999',
  },
  bunnySpecialPrediction: {
    20: '0x9999999999999999999999999999999999999999',
  },
  farmAuction: {
    20: '0x9999999999999999999999999999999999999999',
  },
}
